import { Blockquote, Amazon, InternalLink } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Blockquote,
  Amazon,
  InternalLink,
  React
};